import { render, staticRenderFns } from "./CRReportSummaryTable.vue?vue&type=template&id=0b4bb15f&"
import script from "./CRReportSummaryTable.vue?vue&type=script&lang=js&"
export * from "./CRReportSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports